export default "__VITE_ASSET__5b3c790d__"